import React, { useId } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Icon from './Icon';
import { getPanelDistanceColumnTooltipText } from '../../utils/recruitmentAugmentedMember';

/**
 * DataGrid column header: "Distance (mi)" plus info tooltip (reference ZIP / how miles are computed).
 */
export default function PanelDistanceMilesColumnHeader({ panelRankingContext }) {
    const tipId = useId();
    const text = getPanelDistanceColumnTooltipText(panelRankingContext);

    return (
        <span className="d-inline-flex align-items-center gap-1 flex-shrink-0 text-nowrap pe-1">
            <span className="flex-shrink-0">Distance (mi)</span>
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id={tipId} style={{ maxWidth: 340, textAlign: 'left' }}>
                        {text}
                    </Tooltip>
                }>
                <span
                    className="cursor-pointer d-inline-flex"
                    role="button"
                    tabIndex={0}
                    aria-label="What this distance is measured from"
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
                    }}>
                    <Icon icon="info-solid" size={14} className="opacity-75 flex-shrink-0" />
                </span>
            </OverlayTrigger>
        </span>
    );
}
